/**
 * Action kind: chat — open the site's own chat/enquiry widget.
 *
 * Distinct from whatsapp: this stays on-site. It dispatches an event rather
 * than reaching into any particular widget, so whichever one the site runs can
 * listen without this file knowing about it.
 */

import { el, svg } from '../../dom.js';

const BUBBLE = '<path d="M21 15a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>';

export function render(model) {
	return el(
		'button',
		{
			type: 'button',
			class: 'btn btn-sm w-100 mt-2 rfhq-pc-cta rfhq-pc-cta--chat',
			dataset: { rfhqChat: model.itemCode || model.id, rfhqChatTitle: model.title },
		},
		[svg(BUBBLE, { class: 'rfhq-pc-cta__icon' }), ' ', model.actions.label || 'Ask about this']
	);
}
